import { useNavigation } from "@react-navigation/native";
import { SellScreenProps } from "../../screens/SellScreen";
import { useClearCart } from "../../utils/sale-controller";
import React from "react";
import Sale from "../../../../utilities/data/model/Sale";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { CartContext } from "./components/context";
import Customer from "../../../../utilities/data/model/Customer";

const getObservables = ({ sale }: { sale: Sale }) => ({
  sale: sale.observe(),
  items: sale.items.observe(),
  totals: sale.totals,
  balance: sale.balance,
});

export interface CartProviderProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  children: React.ReactNode;
}

const CartProviderRenderer = ({
  sale,
  items,
  totals,
  balance,
  children,
}: CartProviderProps) => {
  const navigation = useNavigation<SellScreenProps["navigation"]>();

  const clearCart = useClearCart();

  const handleOnClearCart = React.useCallback(() => {
    clearCart().catch((e) => console.log(e));
  }, [clearCart]);

  const handleOnEditCustomer = async (_: Customer) => {
    return sale.customer
      .fetch()
      .then((i) => {
        navigation.navigate("ActionsRootScreen", {
          screen: "CustomerRootScreen",
          params: {
            screen: "EditCustomerScreen",
            params: {
              customerId: i.id,
            },
          },
        });
      })
      .catch((e) => console.log(e));
  };

  const totalItems = items.reduce((acc, item) => {
    return acc + item.quantity;
  }, 0);

  const disabled = !items || items.length == 0;

  return (
    <CartContext.Provider
      value={{
        sale,
        items,
        totals,
        balance,
        handleOnClearCart,
        handleOnEditCustomer,
        navigation,
        disabled,
        totalItems,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

const enhance = withObservables(["sale"], getObservables);

export const CartProvider = enhance(CartProviderRenderer);
